import _ from 'lodash';
import {I18nFunction} from 'i18n';
import {CategoryData} from 'models/app';
import {NavigationItem, NavigationItemType, NavigationSectionType} from 'units/navigation/models';
import {Product} from 'units/marketplace/models';
import {FEATURED} from 'units/services/constants';
import {getMktProductUrl} from '../../../../../common/marketplace/utils';
import {getNavigationTypePrefix} from 'units/navigation/utils';

function getGroupItem(i18n: I18nFunction, prefix: string, item: string, type: NavigationItemType) {
    return {
        title: i18n('navigation', `${prefix}_${item}_title`),
        url: `${type === NavigationItemType.Service ? '/services' : ''}/${item}`,
        description: i18n('navigation', `${prefix}_${item}_description`),
        icon: item,
        type,
    };
}

export function getGroupItems(
    i18n: I18nFunction,
    prefix: string,
    items: string[],
    type: NavigationItemType = NavigationItemType.Default,
) {
    return items.reduce<Record<string, NavigationItem>>((acc, service) => {
        acc[service] = getGroupItem(i18n, prefix, service, type);

        return acc;
    }, {});
}

export function getSocialItems(items: Record<string, NavigationItem>) {
    return Object.entries(items).reduce<Record<string, NavigationItem>>(
        (acc, [key, value]) => ({
            ...acc,
            [key]: {
                ...value,
                type: NavigationItemType.Social,
                blank: true,
                icon: key,
            },
        }),
        {},
    );
}

export function transformMktProductsData(products: Product[]): NavigationItem[] {
    return products.map(({id, marketingInfo: {name, logo}}) => ({
        title: name,
        icon: logo,
        url: getMktProductUrl(id),
        type: NavigationItemType.DefaultWithImg,
    }));
}

export const getCategoryNavItem = ({slug, name}: CategoryData, type: NavigationSectionType) => {
    const prefix = getNavigationTypePrefix(type);

    return {
        title: name,
        url: `/${prefix}#${slug}`,
    };
};

export function getDesktopCategoriesOrder(categories: CategoryData[]) {
    const blocks = _.chunk(categories, 4);
    const blockChunks = blocks.map((block) => {
        const chunks = _.chunk(block, Math.ceil(block.length / 2));

        return _.flatten(_.zip(...chunks));
    });

    return _.flatten(blockChunks).filter(Boolean) as CategoryData[];
}

export function getShortCategoryItems(categories: CategoryData[], type: NavigationSectionType) {
    return categories
        .filter(({slug}) => slug !== FEATURED)
        .map((category) => getCategoryNavItem(category, type));
}
